import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { v4 } from "uuid";

const { getTargetUrl } = experienceBuilderSlice.selectors;
const { _setTargetUrl } = experienceBuilderSlice.actions;

export const setTargetUrl = createAsyncThunk<void, string>(
  "experienceBuilder/setTargetUrl",
  (urlOrPath, { dispatch, getState }) => {
    const current = getTargetUrl(getState());
    const url = new URL(urlOrPath, current);
    url.hash = v4();
    dispatch(_setTargetUrl(url.href));
  }
);
